<template>
  <el-card>


    <el-row>
      <div v-show="showUI">
        <p>{{ $t("login_description") }}</p>
        <br />
        <el-button :loading="loading" class="action-button gradient-button1" type="primary" native-type="submit" block
          @click="govmoLogin">
          {{ $t("login") }}
        </el-button>
        <br />
      </div>
    </el-row>
  </el-card>
</template>

<script>
import i18n from "../i18n";
import { getGovmoLoginURL } from "@/api/user.js";
import { ServerBaseURL, mockMobileIntegration } from "../config.js";
import { env } from "../config.js";

export default {
  data() {
    return {
      loading: false,
      showUI: false,
      redirectPath: '',
    };
  },

  mounted() {
    this.redirectPath = this.$route.query.redirectPath || '';
    if (!mockMobileIntegration && this.$govapp) {
      this.govmoLogin();
    } else {
      this.showUI = true;
    }
  },

  methods: {
    async getGovMoToken() {
      if (this.$govapp && this.$govapp.getToken) {
        const govapp = this.$govapp;
        return new Promise((resolve) => {
          govapp.getToken({
            success(res) {
              console.log('getToken:', res)
              resolve(res.authToken);
            },
            fail() {
              resolve(undefined);
            },
          });
        });
      }
      return undefined;
    },

    async govmoLogin() {
      const lang = i18n.locale;
      const token = await this.getGovMoToken();
      const redirectPath = this.redirectPath;
      console.log("getGovMoToken:", token);


      if (token) {
        const loginUrl = `${ServerBaseURL}/govmo-login-token?env=${env}&lang=${lang}&token=${token}&redirectPath=${redirectPath}`;
        console.log("login url:", loginUrl);
        window.location.href = loginUrl;
      } else {
        const { data } = await getGovmoLoginURL(i18n.locale, env, redirectPath);
        if (data) {
          console.log("login url:", data.url);
          window.location.href = data.url;
        }
      }
    },

    showInputInvalid() {
      this.$message.error(this.$t("login_fail"));
    },
  },
};
</script>